import { IsBoolean, IsOptional, Length } from 'class-validator';

export class ManufacturerConfirmModel {
  @IsBoolean()
  public confirmed: boolean;

  @IsOptional()
  @Length(0, 36)
  public userId?: string;

  constructor(
    confirmed: boolean,
    userId?: string,
  ) {
    this.confirmed = confirmed;
    this.userId = userId;
  }
}
